import antdData from 'antd/lib/locale-provider/en_US'
import localeData from 'react-intl/locale-data/en'

const messages = {
  // general
  copyright: '2019 ForteSitio. All rights reserved',
  language: 'Language',

  // topBar
  'topBar.issuesHistory': 'Issues History',
  'topBar.projectManagement': 'Project Management',
  'topBar.typeToSearch': 'Type to search...',
  'topBar.buyNow': 'Information',
  'topBar.bitcoin': 'Activity',
  'topBar.profileMenu.hello': 'Hello',
  'topBar.profileMenu.billingPlan': 'Billing Plan',
  'topBar.profileMenu.company': 'Company',
  'topBar.profileMenu.role': 'Role',
  'topBar.profileMenu.email': 'Email',
  'topBar.profileMenu.phone': 'Phone',
  'topBar.profileMenu.editProfile': 'Edit Profile',
  'topBar.profileMenu.logout': 'Logout',

  // Layouts.Login
  'user.login.top.back': 'BACK',
  'user.login.top.login': 'LOGIN',
  'user.login.top.about': 'ABOUT',
  'user.login.top.support': 'SUPPORT',

  // Pages.User.Login
  'user.login.title': 'WELCOME TO THE INDUSTRY 4.0 CLOUD PLATFORM',
  'user.login.instructions1': 'Connect to the cloud and log all information',
  'user.login.instructions2': 'Design the layout as your company needs',
  'user.login.instructions3':
    'Get alarms and notifies with our mobil app, query and monitor your process',
  'user.login.block.title': 'PLEASE LOG IN',
  'user.login.block.email': 'Email',
  'user.login.block.email.initial.value': 'user@domain.com',
  'user.login.block.email.required.message': 'Please input your e-mail address',
  'user.login.block.password': 'Password',
  'user.login.block.password.initial.value': 'password',
  'user.login.block.password.required.message': 'Please input your password',
  'user.login.block.rememberme': 'Remember me',
  'user.login.block.forgot.password': 'Forgot Password?',
  'user.login.block.button.login': 'Login',
  'user.login.block.register': 'Register',
  'user.login.block.register.if': "if you don't have account",
  'user.login.block.another': 'User another service to Log In',

  // pages.user.forgot
  'user.forgot.caption': 'RESTORE PASSWORD',
  'user.forgot.username': 'Username (email)',
  'user.forgot.username.message': 'Please input username or email',
  'user.forgot.backlogin': 'Back to login',
  'user.forgot.button': 'Restore Password',

  // pages.user.register
  'user.register.title': 'REGISTRATION FORM',
  'user.register.instructions1':
    'Please fill the information requested to start your registration process',
  'user.register.instructions2': "You'll receive an email to complete your regitration",
  'user.register.form.caption': 'Registration',
  'user.register.form.username.message': 'Email or Nickname',
  'user.register.form.username.error.message': 'Please input your email address',
  'user.register.form.password.message': 'Input your password',
  'user.register.form.password.error.message': 'Input your password',
  'user.register.form.passwordConfirm.message': 'Confirm your password',
  'user.register.form.passwordConfirm.error.message':
    'Two passwords that you enter is inconsistent!',
  'user.register.form.button': 'Sign Up',
  'user.register.form.invitation.message': 'Invitation code (optional)',
  'user.register.form.invitation.error.message': 'add an invitations code if you have one',
  'user.register.form.suscript': 'Mail Subscription',
  'user.register.another': 'User another service to Sign up',

  // pages footer
  'footer.termsOfUse': 'TERMS OF USE',
  'footer.compliance': 'COMPLIANCE',
  'footer.confidential': 'CONFIDENTIAL INFORMATION',
  'footer.support': 'SUPPORT',
  'footer.contacts': 'CONTACTS',

  // pages.tags
  'tag.path': 'Route path to Tag',
  'tag.value': 'Value for Tag',

  // issuesHistory
  'issuesHistory.currentSearch': 'Current Search',
  'issuesHistory.searchForIssues': 'Search for issues',
  'issuesHistory.opened': 'Opened',
  'issuesHistory.PLAIN4-253': 'PLAIN4-253 Virtual PLC...',
  'issuesHistory.PLAIN4-234': 'PLAIN4-234 Process des...',
  'issuesHistory.PLAIN4-424': 'PLAIN4-424 System gran...',
  'issuesHistory.more': 'More...',
  'issuesHistory.filters': 'Filters',
  'issuesHistory.myOpenIssues': 'My open issues',
  'issuesHistory.reportedByMe': 'Reported by me',
  'issuesHistory.Settings': 'Settings',

  // project management
  'projects.active': 'Active',
  'projects.controlMultiloop': 'Multiple control loop',
  'projects.biolerRoom': 'Boiler room',
  'projects.mechatronicLab': 'Mechatronic Lab',
  'projects.inactive': 'Inactive',
  'projects.plcExamples': 'PLC Examples',
  'projects.settings': 'Settings',

  // settings
  'settings.theme': 'Theme Settings',
  'settings.menuTop': 'Menu Top (Horizonthal)',
  'settings.collapsed': 'Collapsed Menu',
  'settings.shadow': 'Menu Shadow',
  'settings.light': 'Light Theme',
  'settings.borderless': 'Borderless Cards',
  'settings.squared': 'Squared Borders',
  'settings.fixed': 'Fixed Width',

  // dashboard
  'dashboard.monitor': 'Monitor control Tags',
  'dashboard.tagsRefreshed': 'Refreshed Values',
  'dashboard.tagsMessage': 'The values showed here are updated each 4 seconds',
  'dashboard.path': 'Path',
  'dashboard.value': 'Value',
  'dashboard.origin': 'Origin',
  'dashboard.dateTime': 'Date & Time',
  'dashboard.products': 'Products',
  'dashboard.productsHeader': 'Product List',
  'dashboard.productsInstruction': 'Show or Edit product list',
  'dashboard.company': 'Company',
  'dashboard.companyHeader': 'Companies',
  'dashboard.companyInstruction': 'Show or edit company list',
  'dashboard.users': 'Users',
  'dashboard.usersInstruction': 'Show or edit users list',
  'dashboard.usersHeader': 'Usuarios',
  'dashboard.group': 'Groups',
  'dashboard.groupHeader': 'Groups',
  'dashboard.groupInstruction': 'Show or edit groups',
  'dashboard.project': 'Projects',
  'dashboard.projectInstruction': 'Show or edit project list',
  'dashboard.projectHeader': 'Projects',
  'dashboard.site': 'Site',
  'dashboard.siteHeader': 'Site',
  'dashboard.siteInstruction': 'Show or edit site list',
  'dashboard.device': 'Devices',
  'dashboard.deviceHeader': 'Devices',
  'dashboard.deviceInstruction': 'Show or edit device list',
  'dashboard.tag': 'Tags',
  'dashboard.tagHeader': 'Tags',
  'dashboard.tagInstruction': 'Show or edit tag list',
  'dashboard.use': 'Use/Measure unit',

  // update Tags
  'updateTags.setTagValue': 'Set tag value',
  'updateTags.tagPath': 'Tag path',
  'updateTags.tagValue': 'Tag value',
  'updateTags.send': 'Send',
  'updateTags.cancel': 'Cancel',

  // user profile
  'userProfile.title': 'User Profile',
  'userProfile.systemInfo': 'System Information',
  'userProfile.login': 'Login Name',
  'userProfile.nickName': 'Nick Name',
  'userProfile.status': 'Status',
  'userProfile.firstName': 'First Name',
  'userProfile.lastName': 'Last Name',
  'userProfile.contactInfo': 'Contact Information',
  'userProfile.email': 'E-Mail',
  'userProfile.mobile': 'Mobile Phone #',
  'userProfile.securityInfo': 'Security Info',
  'userProfile.password': 'Password',
  'userProfile.confirm': 'Confirm password',
  'userProfile.save': 'Save',
  'userProfile.cancel': 'Cancel',
  'userProfile.drag': 'Click or drag file to this area to upload an image',
  'userProfile.selectFile': 'Select file',

  // navigation
  'navigation.home': 'Home',

  // menu
  'menu.settings.title': 'Settings',
  'menu.dashboardAlpha.title': 'Dashboard',
  'menu.pricingTable.title': 'Update Tags',
  'menu.userProfile.title': 'User Profile',
  'menu.company.title': 'Company',
  'menu.project.title': 'Project',
  'menu.platform.title': 'Platform',
  'menu.analysis.title': 'Analysis',

  // Company Menu
  'menu.companyGroups.title': 'Group',
  'menu.companyUsers.title': 'Users',
  'menu.companyGroupsUsers.title': 'Users in Groups',

  // Platform Menu
  'menu.platformProducts.title': 'Products',
  'menu.platformCompany.title': 'Company',
  'menu.platformUsers.title': 'Usuarios',

  // Project Menu
  'menu.projectProjects.title': 'Projects',
  'menu.projectSites.title': 'Sites',
  'menu.projectDevices.title': 'Devices',
  'menu.projectTags.title': 'Tags',

  // table common
  'table.operation': 'Operation',
  'table.deleteMessage': 'Delete Record?',

  // action buttons
  'item.add': 'Add',
  'item.delete': 'Delete',
  'item.edit': 'Edit',

  // column names  common
  'data.id': 'id',
  'data.uid': 'uuid',
  'data.sysname': 'System Name',
  'data.nickname': 'Nick Name',
  'data.status': 'Status',
  'data.version': 'Version',
  'data.datetimedatajson': 'DateTime Data JSON',
  'data.sysdatajson': 'System Data JSON',
  'data.extradatajson': 'Extra Data',
  'data.operdatajson': 'Operations data',
  'data.details': 'Details',

  // status values
  'status.active': 'Active',
  'status.created': 'Created',
  'status.stopped': 'Stopped',
  'status.cancelled': 'Cancelled',
  'status.done': 'Done',

  // product column names
  'product.sku': 'SKU',
  'product.price': 'Price',
  'product.kind': 'Product Kind',
  'product.path': 'Product Path',
  'product.photo': 'Photo',
  'product.details': 'Details JSON',

  // product kinds
  'productKind.service': 'Service',
  'productKind.storage': 'Storage',
  'productKind.electronic': 'Electronic',

  // company column names
  'company.photo': 'Photo',
  'company.details': 'Details JSON',

  // group column names
  'company.id': 'CompanyId',
  'company.uid': 'CompanyUid',
  'user.id': 'UserId',
  'user.uid': 'UserUid',
  'group.id': 'GroupId',
  'group.uid': 'GroupUid',
  'group.master': 'SubGroup Of',
  'group.grouping': 'Usuarios del grupo',

  // project colum names
  'project.masterUser': 'Project Administrator',
  'project.users': 'Project users',
  'project.groups': 'Project groups',

  // sites colum names
  'site.masterUser': 'Site manager',
  'site.details': 'Details',

  // device column names
  'device.kind': 'Kind',
  'device.projectMaster': 'Project',
  'device.siteMaster': 'Site',
  'device.details': 'Details',
  'device.kindLocal': 'Local',
  'device.kindRemote': 'Remote',
  'device.kindAuroraHMI': 'Aurora HMI',
  'device.path': 'Path',

  // tags column names
  'tag.kind': 'Origin',
  'tag.type': 'Type',
  'tag.readonly': 'Read Only',
  'tag.persistent': 'Log history',
  'tag.deviceMaster': 'Device',
  'tag.details': 'Details',
  'tag.kindCalculated': 'Calculated',
  'tag.kindLocal': 'Local',
  'tag.kindRemote': 'Remote',
  'tag.typeBoolean': 'Bit',
  'tag.typeInteger': 'Integer',
  'tag.typeFloat': 'Float',
  'tag.typeString': 'String',

  // analysis page messages
  'analysis.title': 'Analysis',
  'analysis.dashboard': 'Project: ',
  'analysis.dataRefreshed': 'Trends chart',
  'analysis.tagsMessage': 'Trend data',
  'analysis.selDevice': 'Device: ',
  'analysis.selTag': 'Tag: ',
}

export default {
  locale: 'en-US',
  antdData,
  localeData,
  messages,
}
